import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dashboard-section__content" }
const _hoisted_2 = { class: "dashboard-section__title" }
const _hoisted_3 = { class: "dashboard-section__subtitle" }
const _hoisted_4 = { class: "dashboard-section__description" }
const _hoisted_5 = {
  key: 0,
  class: "dashboard-section__action"
}

import { useIsMobile, useIsSmallMobile } from '@nextcloud/vue/composables/useIsMobile'


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardSection',
  props: {
    wide: { type: Boolean, default: false },
    title: { default: '' },
    subtitle: { default: '' },
    description: { default: '' }
  },
  setup(__props: any) {


const isSmallMobile = useIsSmallMobile()
const isMobile = useIsMobile()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dashboard-section", {
			'dashboard-section--wide': __props.wide && !_unref(isSmallMobile),
			'dashboard-section--list': _ctx.$slots.list,
		}])
  }, [
    (!_unref(isSmallMobile))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["dashboard-section__bar", {
				'dashboard-section__bar--narrow': _ctx.$slots.list || _unref(isMobile),
				gradient: !_ctx.$slots.image || _unref(isMobile),
				'image-container': _ctx.$slots.image,
			}])
        }, [
          (!(_ctx.$slots.list || _unref(isMobile)))
            ? _renderSlot(_ctx.$slots, "image", { key: 0 })
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.subtitle), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.description), 1),
      _renderSlot(_ctx.$slots, "list"),
      (_ctx.$slots.action)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "action")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})